// Phase C.5e.2 — DIVISION SCHEDULE BACK-NAV AUTHORITY. Pure navigation-
// target resolver, deliberately kept OUT of scheduleController.js (which
// is data-loading only) and OUT of SchedulePage.js (which imports
// react-router-dom and therefore can never be unit-tested directly in
// this environment — see scheduleController.test.js's own header). This
// file has neither dependency, so it's directly testable.
//
// BROWSER-FOUND BUG THIS FILE FIXES — Division-mode's back link was a
// hardcoded "← Seasons & Divisions" pointing at
// /my-programs/:programId/seasons, a Program-management destination. A
// plain Team Head Coach can legitimately REACH Division mode (via their
// own Team's "View Full Division →" link) without ever holding Program-
// level authority — clicking that link produced "Program not found, or
// you don't have Program-level access to it." The fix is authority-aware
// navigation, not a broadened permission: never expose a link to a
// destination the viewer cannot actually use.
//
// `fromTeamId` — the originating Team, when Division mode was reached
// via a Team-focused "View Full Division →" link (passed as the
// `?fromTeam=` query param — see SchedulePage.js's own divisionHref).
// Trusted only insofar as it resolves to a REAL entry in `perTeam` (the
// current viewer's own already-authorized Division membership list,
// from scheduleController.js) — an absent, forged, or cross-Division
// value simply fails to resolve and falls through to the safe "My
// Teams" fallback below, never a broken or misleading destination.
export function resolveDivisionBackNav({ canManage, programId, fromTeamId, perTeam }) {
  if (canManage) {
    // Program Owner/Admin — the only viewer this destination is actually
    // built for.
    return { label: '← Seasons & Divisions', href: `/my-programs/${programId}/seasons` };
  }
  const fromTeamEntry = fromTeamId ? (perTeam || []).find(e => e.team.id === fromTeamId) : null;
  if (fromTeamEntry) {
    return { label: `← ${fromTeamEntry.team.team_name}`, href: `/my-teams/${fromTeamId}/schedule` };
  }
  // No Program authority AND no valid originating Team context (a direct
  // URL visit, or a fromTeam that didn't resolve) — /my-teams is safe for
  // any authenticated viewer, never a dead end.
  return { label: '← My Teams', href: '/my-teams' };
}
